import React from 'react';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';
import columns from '../../../../../../react-table/helpers/columns';
import DrillDownLink from '../../../../../../react-table/helpers/drillDownLink';
import { formattedFloatSumTotal, sumTotal } from '../../../../../../react-table/helpers/rowTotals';
import HeaderChartButton from '../../../../../common/components/HeaderChartButton';
import charts from './DespatchMeasurementsHourlyEvolutionCharts';

export default (data) => {
  const {
    TextColumn, DateColumn, NumberColumn, PercentageColumn, FloatColumn, DrillDownColumn,
  } = columns(data);

  return setChartMeta => [
    {
      Header: '',
      columns: [
        new DateColumn(
          'Close date',
          'despatchClosedDate',
        ).withTotalHeader('Total'),
        new TextColumn(
          'Hour',
          'hour',
        ),
      ],
    },
    {
      Header: 'Despatch count',
      drillDownLink: new DrillDownLink(
        ReportDefinitions.DESPATCH_MONITORING_RESPONSE_PERFORMANCE,
        'despatchClosedDate',
      ),
      columns: [
        new DrillDownColumn(new NumberColumn(
          'PREDES',
          'despatchCount',
        ).withWidth(120)
          .withTotalHeader(sumTotal)),
      ],
    },
    {
      Header: () => (
        <HeaderChartButton
          title="Receptacle count"
          action={setChartMeta}
          chartMeta={charts.receptacleCount}
        />
      ),
      drillDownLink: new DrillDownLink(
        ReportDefinitions.DESPATCH_MONITORING_RECEPTACLE_DETAILS,
        'despatchClosedDate',
      ),
      columns: [
        new DrillDownColumn(new NumberColumn(
          'PREDES',
          'predesCount',
        ).withTotalHeader(sumTotal)),
        new DrillDownColumn(new NumberColumn(
          'PREDES with RESDES',
          'predesWithResdesCount',
        ).withTotalHeader(sumTotal)),
        new DrillDownColumn(new NumberColumn(
          'PREDES without RESDES',
          'predesWithoutResdesCount',
        ).withTotalHeader(sumTotal)),
        new DrillDownColumn(new PercentageColumn(
          '% RESDES / PREDES',
          'resdesPredesCountPercentage',
        )),
      ],
    },
    {
      Header: () => (
        <HeaderChartButton
          title="Receptacle weight"
          action={setChartMeta}
          chartMeta={charts.receptacleWeight}
        />
      ),
      drillDownLink: new DrillDownLink(
        ReportDefinitions.DESPATCH_MONITORING_RECEPTACLE_DETAILS,
        'despatchClosedDate',
      ),
      columns: [
        new DrillDownColumn(new FloatColumn(
          'PREDES',
          'predesWeight',
        ).withTotalHeader(formattedFloatSumTotal)),
        new DrillDownColumn(new FloatColumn(
          'PREDES with RESDES',
          'predesWithResdesWeight',
        ).withTotalHeader(formattedFloatSumTotal)),
        new DrillDownColumn(new FloatColumn(
          'PREDES without RESDES',
          'predesWithoutResdesWeight',
        ).withTotalHeader(formattedFloatSumTotal)),
        new DrillDownColumn(new PercentageColumn(
          '% RESDES / PREDES',
          'resdesPredesWeightPercentage',
        )),
      ],
    },
    {
      Header: () => (
        <HeaderChartButton
          title="Event targets"
          action={setChartMeta}
          chartMeta={charts.eventTargets}
        />
      ),
      drillDownLink: new DrillDownLink(
        ReportDefinitions.DESPATCH_MONITORING_EVENT_TARGETS,
        'despatchClosedDate',
      ),
      columns: [
        new DrillDownColumn(new NumberColumn(
          'CST measurable',
          'cstMeasureableCount',
        ).withTotalHeader(sumTotal)),
        new DrillDownColumn(new NumberColumn(
          'RESDES <= CST',
          'resdesCapturedBeforeOrEqualToCSTCount',
        ).withTotalHeader(sumTotal)),
        new DrillDownColumn(new NumberColumn(
          'RESDES > CST',
          'resdesCapturedAfterCSTCount',
        ).withTotalHeader(sumTotal)),
        new DrillDownColumn(new PercentageColumn(
          '<= CST%',
          'onTimeCSTPercentage',
        )),
      ],
    },
  ];
};
